export var ModalType;
(function (ModalType) {
    ModalType["RetailerInfo"] = "retailer-info";
    ModalType["ProductAddedToCart"] = "product-added-to-cart";
    ModalType["Loading"] = "loading";
    ModalType["CookieConsent"] = "cookie-consent";
    ModalType["GeoIP"] = "geo-ip";
})(ModalType || (ModalType = {}));
